export default "__VITE_ASSET__C_a_w7GR__"